import _ from "lodash";

const initialState = {
  entities: {
    "BTS.CEN": {
      id: "BTS.CEN",
      title: {
        en: "BTS Siam",
        th: "สยาม",
      },
      lines: ["bts.silom", "bts.sukhumvit"],
      location: {
        position: {
          _lat: 13.7454502,
          _long: 100.5327578,
        },
      },
      type: "BTS",
      value: "BTS.CEN",
      label: "BTS Siam",
    },
  },
  fetchStatuses: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ENTITIES/POINT_OF_INTERESTS/RECEIVED":
      return {
        ...state,
        entities: _.reduce(
          action.items,
          (sum, item) => {
            return { ...sum, [item.id]: item };
          },
          state.entities
        ),
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/pointOfInterests.js